<template>
  <div class="mainBox" id="app">
    <div class="right">
      <div class="rightBox">
        <div class="lang-switch">
          <a @click="SwitchLang">{{ $i18n.locale == lang.enUS ? 'Tiếng Việt' : 'English' }}</a>
        </div>
        <div class="logo-container">
          <img src="@/assets/loginLogo.png" alt="" />
        </div>
        <div class="title">
          {{ $i18n.locale == lang.enUS ? 'P2P Console' : 'FINOVA Bảng điều khiển P2P' }}
        </div>
        <div class="subtitle">
          {{
            $i18n.locale == lang.enUS
              ? 'Welcome to Finova Management Platform'
              : 'Chào mừng bạn đến với trang quản trị Finova'
          }}
        </div>
        <a-form id="formLogin" class="user-layout-login" ref="formLogin" :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              size="large"
              type="text"
              :placeholder="$t('userName')"
              v-decorator="[
                'username',
                {
                  rules: [{ required: true, message: $t('home.userNameTips') }, { validator: handleUsernameOrEmail }],
                  validateTrigger: 'change',
                },
              ]"
            >
              <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              type="password"
              autocomplete="false"
              :placeholder="$t('password')"
              v-decorator="[
                'password',
                { rules: [{ required: true, message: $t('home.passwordTips') }], validateTrigger: 'blur' },
              ]"
            >
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              type="text"
              autocomplete="false"
              :placeholder="$t('code2')"
              v-model="googleCode"
              v-decorator="[
                'googleCode',
                { rules: [{ required: false, message: $t('home.code') }], validateTrigger: 'blur' },
              ]"
            >
              <a-icon slot="prefix" type="google" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
            <canvas ref="qrcodeCanvas" v-show="showQrCode" style="margin-top: 10px" />
          </a-form-item>

          <div style="display: flex; justify-content: center; color: #52c41a; margin-bottom: 10px; font-size: 12px">
            <a style="color: #52c41a" @click="goToGoogleAuthGuide">{{
              $i18n.locale == lang.enUS
                ? 'How to get Google verification code?'
                : 'Làm thế nào để lấy mã xác thực Google?'
            }}</a>
          </div>
          <a-form-item style="margin-top: 24px">
            <a-button
              size="large"
              type="primary"
              htmlType="submit"
              class="login-button"
              :loading="state.loginBtn"
              :disabled="state.loginBtn"
              >{{ $t('confirm') }}
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import lang from '../../i18n/lang'
import i18n from '../../i18n'
import QRCode from 'qrcode'

export default {
  data() {
    return {
      showGoogleAuth: false,
      showQrCode: false,
      googleCode: '',
      spin: false,
      lang,
      customActiveKey: 'tab1',
      loginBtn: false,
      image: '',
      sessionId: '',
      loginType: 0,
      isLoginError: false,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        loginType: 0,
        smsSendBtn: false,
      },
      redirect: undefined,
      tz: false,
    }
  },
  computed: {
    global: () => process.env.VUE_APP_GLOBAL_NAME,
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true,
    },
  },
  created() {
    // this.requiredTwoStepCaptcha = true
    if (window.location.hostname.includes('allwfinancing') || window.location.host.includes('allwfinancing')) {
      this.tz = true
    } else {
      this.tz = false
    }
    //  this.generateMethods()
  },
  mounted() {},
  methods: {
    ...mapActions(['Login', 'Logout']),
    ...mapActions('language', ['setLanguage']),
    SwitchLang() {
      const key = this.$i18n.locale == lang.enUS ? lang.esUS : lang.enUS
      this.$i18n.locale = key
      this.setLanguage(key)
    },

    goToGoogleAuthGuide() {
      console.log('Navigating to googleAuthGuide...')
      this.$router.push('/user/googleAuthGuide').catch((err) => {
        console.error('Router error:', err)
      })
    },

    handleUsernameOrEmail(rule, value, callback) {
      const { state } = this
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        customActiveKey,
        Login,
      } = this

      state.loginBtn = true
      const validateFieldsKey =
        customActiveKey === 'tab1' ? ['username', 'password', 'googleCode'] : ['mobile', 'captcha']
      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          const loginParams = {
            loginName: values.username,
            password: values.password,
            authCode: values.googleCode,
            sessionId: this.sessionId,
          }
          Login(loginParams)
            .then((res) => {
              this.loginSuccess(res)
            })
            .catch((err) => {
              this.requestFailed(err)
            })
            .finally(() => {
              state.loginBtn = false
            })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    stepCaptchaSuccess() {
      this.loginSuccess()
    },
    stepCaptchaCancel() {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    loginSuccess(res) {
      if (res.data.googleAuth) {
        this.showGoogleAuth = true
        this.showQrCode = true
        this.$nextTick(() => {
          setTimeout(() => {
            this.$notification.warn({ message: 'QR Code Expired', description: 'Google QR code has expired, please login again' })
            this.showGoogleAuth = false
            this.showQrCode = false
          }, 5 * 60 * 1000)

          QRCode.toCanvas(
            this.$refs.qrcodeCanvas,
            res.data.googleAuth,
            {
              width: 200,
              margin: 2,
              color: {
                dark: '#000000',
                light: '#ffffff',
              },
            },
            function (err) {
              console.log(err)
            }
          )
        })
        return
      }

      // Ensure English is used by default after login
      const defaultLang = 'en-US'
      this.$i18n.locale = defaultLang
      this.setLanguage(defaultLang)

      window.location.reload()
      const self = this
      setTimeout(() => {
        const message = i18n.tc('home.welcome')
        const description = `${i18n.tc(timeFix())}, ${i18n.tc('home.welcomeBack')}`
        this.$notification.success({
          message,
          description,
        })
      }, 1000)
      this.isLoginError = false
    },
    requestFailed(err) {
      const self = this
      this.isLoginError = true
      this.form.code = ''
      this.$notification['error']({
        message: self.$t('error'),
        description: err.message || self.$t('requestFail'),
        duration: 4,
      })
    },
  },
}
</script>

<style lang="less" scoped>
* {
  margin: 0px;
  padding: 0px;
}

.ant-btn-primary {
  // background: #1890ff !important;
  height: 50px !important;
  width: 100% !important;
  border-radius: 10px;
  display: block !important;
  margin: 0 auto !important;
  border-style: none !important;
}

a {
  // color: #1890ff !important;
  cursor: pointer;
}

.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  border-color: #e6f7e6 !important;
  border-right-width: 1px !important;
}

.mainBox {
  position: relative;
  width: 100vw !important;
  height: 100vh !important;
  overflow: hidden !important;
  background-image: url('../../assets/loginBgc.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 0;

  .right {
    position: relative;
    z-index: 1000;
    width: 450px;
    height: auto;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    border-radius: 16px;

    .rightBox {
      width: 100%;

      .lang-switch {
        position: absolute;
        top: 20px;
        right: 20px;
        a {
          color: #52c41a;
          font-size: 14px;
        }
      }

      .logo-container {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
        img {
          width: 80px;
          height: 80px;
        }
      }

      .title {
        text-align: center;
        color: #333;
        font-size: 26px;
        font-weight: 600;
        margin-bottom: 10px;
        line-height: 1.4;
      }

      .subtitle {
        text-align: center;
        color: #999;
        font-size: 14px;
        margin-bottom: 40px;
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .left {
    display: none;
  }
}

@media (max-width: 800px) {
  .mainBox {
    position: relative;
    width: 100vw !important;
    height: 100vh !important;
    overflow: hidden !important;
    background-image: url('../../assets/loginBgc.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    margin: 0px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 0;

    .right {
      position: relative;
      z-index: 1000;
      width: 90%;
      max-width: 450px;
      height: auto;
      background: #ffffff;
      padding: 30px;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .rightBox {
        width: 100%;

        .title {
          display: flex;
          align-items: center;
          color: #333;
          width: 100%;
          font-size: 36px;
          font-weight: 600;
          margin-bottom: 50px;
          line-height: 1.2;
          img {
            width: 60px;
            height: 60px;
            margin-right: 15px;
          }
          div {
            word-wrap: break-word;
            white-space: normal;
          }
        }
      }
    }
  }
}

.ant-form-item {
  margin-bottom: 20px;
}

.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    // background-color: ;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #cdaa7d;
      }
    }

    .register {
      float: right;
    }
  }
}

.mask {
  width: 150px;
  height: 40px;
  background: rgba(255, 255, 255, 0.8);
}
</style>
